import { render, staticRenderFns } from "./exitedEmployee.vue?vue&type=template&id=d0555bf0&"
import script from "./exitedEmployee.vue?vue&type=script&lang=js&"
export * from "./exitedEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports